<template>
  <div class="toolbar">
    <div class="md-layout">
      <div class="md-layout-item md-large-size-100">
        <md-card>
          <md-card-content>
            <md-button
              native-type="button"
              class="md-success"
              :disabled="disabled"
              @click="generateSchedule"
            >
              <span class="md-label">
                <md-icon class="material-icons">extension</md-icon>
              </span>
              {{ data.language.schedule.button.generate.label }}
            </md-button>
            <md-button
              native-type="button"
              class="md-primary"
              :disabled="disabled || touched.scheduleItems"
              @click="generatePdf"
            >
              <span class="md-label">
                <md-icon class="material-icons">picture_as_pdf</md-icon>
              </span>
              {{ data.language.schedule.button.generatePdf.label }}
            </md-button>
            <md-button
              :disabled="disabled"
              native-type="button"
              :class="getLockBtnClass"
              @click="toggleLock"
            >
              <span class="md-label">
                <md-icon class="material-icons">{{ getLockClass }}</md-icon>
              </span>
              {{ getLockUnlockButtonLabel }}
            </md-button>
            <md-button
              v-if="hasReserveRoutes()"
              :disabled="disabled"
              native-type="button"
              :class="getReserveLockBtnClass"
              @click="toggleReserveLock"
            >
              <span class="md-label">
                <md-icon class="material-icons">{{
                  getReserveLockClass
                }}</md-icon>
              </span>
              {{ getReserveLockUnlockButtonLabel }}
            </md-button>
            <md-button
              :disabled="disabled"
              native-type="button"
              class="md-danger"
              @click="resetSchedule"
            >
              <span class="md-label">
                <md-icon class="material-icons">restart_alt</md-icon>
              </span>
              {{ data.language.schedule.button.reset.label }}
            </md-button>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    // console.log('Component mounted.')
  },
  props: ["data", "disabled", "touched"],
  computed: {
    getHelpBtnClass: function() {
      return this.data.helpToolTipsEnabled ? "md-success" : "md-info";
    },
    getLockClass: function() {
      return this.isLockedUnlocked() ? "lock" : "lock_open";
    },
    getLockBtnClass: function() {
      return this.isLockedUnlocked() ? "md-danger" : "md-success";
    },
    getReserveLockClass: function() {
      return this.isReserveLockedUnlocked() ? "lock" : "lock_open";
    },
    getReserveLockBtnClass: function() {
      return this.isReserveLockedUnlocked() ? "md-danger" : "md-success";
    },
    getLockUnlockButtonLabel: function() {
      return this.isLockedUnlocked()
        ? this.data.language.schedule.button.lock.label2
        : this.data.language.schedule.button.lock.label;
    },
    getReserveLockUnlockButtonLabel: function() {
      return this.isReserveLockedUnlocked()
        ? this.data.language.schedule.button.lockReserve.label2
        : this.data.language.schedule.button.lockReserve.label;
    },
    getLockUnlockToolTip: function() {
      return this.isLockedUnlocked()
        ? this.data.language.schedule.button.lock.toolTip2
        : this.data.language.schedule.button.lock.toolTip;
    },
    getReserveLockUnlockToolTip: function() {
      return this.isReserveLockedUnlocked()
        ? this.data.language.schedule.button.lockReserve.toolTip2
        : this.data.language.schedule.button.lockReserve.toolTip;
    },
    getPublishButtonLabel: function() {
      return this.data.schedule.publishStatus
        ? this.data.language.schedule.button.publish.label
        : this.data.language.schedule.button.publish.label2;
    },
    getPublishClass: function() {
      return this.data.schedule.publishStatus ? "help" : "help_outline";
    },
    getPublishToolTip: function() {
      return this.data.schedule.publishStatus
        ? this.data.language.schedule.button.publish.toolTip2
        : this.data.language.schedule.button.publish.toolTip;
    },
    getPublishBtnClass: function() {
      return this.data.schedule.publishStatus ? "md-success" : "md-warning";
    },
    getHelpToolTip: function() {
      return this.data.helpToolTipsEnabled
        ? this.data.language.schedule.button.help.toolTip2
        : this.data.language.schedule.button.help.toolTip;
    }
  },
  methods: {
    isLockedUnlocked: function() {
      try {
        for (var day in this.data.schedule.days) {
          for (var group in this.data.schedule.days[day].groups) {
            for (var route in this.data.schedule.days[day].groups[group]
              .routes) {
              if (
                this.data.schedule.days[day].groups[group].routes[route]
                  .reserve === true ||
                this.data.schedule.days[day].groups[group].routes[route]
                  .reserve === 1
              ) {
                continue;
              }
              for (var shift in this.data.schedule.days[day].groups[group]
                .routes[route].shifts) {
                return this.data.schedule.days[day].groups[group].routes[route]
                  .shifts[shift].values.locked;
              }
            }
          }
        }
      } catch (e) {
        return false;
      }
    },
    toggleLock: function() {
      var locked = !this.isLockedUnlocked();

      for (var day in this.data.schedule.days) {
        for (var group in this.data.schedule.days[day].groups) {
          for (var route in this.data.schedule.days[day].groups[group].routes) {
            for (var shift in this.data.schedule.days[day].groups[group].routes[
              route
            ].shifts) {
              this.data.schedule.days[day].groups[group].routes[route].shifts[
                shift
              ].values.locked = locked;
            }
          }
        }
      }
    },
    isReserveLockedUnlocked: function() {
      try {
        for (var day in this.data.schedule.days) {
          for (var group in this.data.schedule.days[day].groups) {
            for (var route in this.data.schedule.days[day].groups[group]
              .routes) {
              if (
                this.data.schedule.days[day].groups[group].routes[route]
                  .reserve !== true &&
                this.data.schedule.days[day].groups[group].routes[route]
                  .reserve !== 1
              ) {
                continue;
              }
              for (var shift in this.data.schedule.days[day].groups[group]
                .routes[route].shifts) {
                return this.data.schedule.days[day].groups[group].routes[route]
                  .shifts[shift].values.locked;
              }
            }
          }
        }
      } catch (e) {
        return false;
      }
    },
    toggleReserveLock: function() {
      var locked = !this.isReserveLockedUnlocked();

      for (var day in this.data.schedule.days) {
        for (var group in this.data.schedule.days[day].groups) {
          for (var route in this.data.schedule.days[day].groups[group].routes) {
            if (
              this.data.schedule.days[day].groups[group].routes[route]
                .reserve !== true &&
              this.data.schedule.days[day].groups[group].routes[route]
                .reserve !== 1
            ) {
              continue;
            }
            for (var shift in this.data.schedule.days[day].groups[group].routes[
              route
            ].shifts) {
              this.data.schedule.days[day].groups[group].routes[route].shifts[
                shift
              ].values.locked = locked;
            }
          }
        }
      }
    },
    hasReserveRoutes: function() {
      try {
        for (var day in this.data.schedule.days) {
          for (var group in this.data.schedule.days[day].groups) {
            for (var route in this.data.schedule.days[day].groups[group]
              .routes) {
              if (
                this.data.schedule.days[day].groups[group].routes[route]
                  .reserve !== true &&
                this.data.schedule.days[day].groups[group].routes[route]
                  .reserve !== 1
              ) {
                continue;
              }

              return true;
            }
          }
        }
      } catch (e) {
        return false;
      }
      return false;
    },
    toggleHelp: function() {
      this.data.helpToolTipsEnabled = !this.data.helpToolTipsEnabled;
    },
    togglePublish: function() {
      this.data.schedule.publishStatus =
        this.data.schedule.publishStatus ||
        this.data.schedule.publishStatus != "0"
          ? 0
          : 1;
    },
    resetSchedule: function() {
      for (var day in this.data.schedule.days) {
        for (var group in this.data.schedule.days[day].groups) {
          for (var route in this.data.schedule.days[day].groups[group].routes) {
            for (var shift in this.data.schedule.days[day].groups[group].routes[
              route
            ].shifts) {
              if (
                this.data.schedule.days[day].groups[group].routes[route].shifts[
                  shift
                ].values.locked
              ) {
                continue;
              }
              this.data.schedule.days[day].groups[group].routes[route].shifts[
                shift
              ].values.driver = "";
            }
          }
        }
      }
    },
    generateSchedule: function() {
      this.$emit("generateSchedule", true);
    },
    generatePdf: function() {
      this.$emit("generatePdf", true);
    }
  }
};
</script>
<style lang="scss" scoped>
.toolbar .md-layout .md-card {
  margin-bottom: 5px;
  margin-top: 5px;
}
</style>
